<template>
  <div>
    <!--begin: Navigation -->
    <div class="kt-notification">
      <div class="kt-notification__custom kt-space-between flex-column">
        <a
          href="#"
          v-on:click.prevent="onManageMfa()"
          class="btn btn-label btn-label-brand btn-sm btn-bold w-100 mb-2"
          >Manage MFA</a
        >
        <a
          href="#"
          v-on:click.prevent="onLogout()"
          class="btn btn-label btn-label-brand btn-sm btn-bold w-100"
          >Sign Out</a
        >
      </div>
    </div>
    <!--end: Navigation -->
  </div>
</template>

<script>
import { LOGOUT } from "@/store/auth.module";

export default {
  name: "KTDropdownUser",
  methods: {
    onLogout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }))
        .catch(() => this.$router.push({ name: "login" }));
    },
    onManageMfa() {
      this.$router.push({ name: "mfa-devices" });
    }
  },
  computed: {
    currentUser() {
      let user = this.$store.getters.currentUser;
      user = user.hasOwnProperty("attributes")
        ? user
        : { attributes: { email: "", name: "" } };
      return user.attributes;
    },
    currentUserFirstLetter() {
      if (this.currentUser.name) return this.currentUser.name[0];

      return "";
    }
  }
};
</script>
